import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    codeProp: 'dvUserCode',
    detailIdProp: 'dvId',
    detailUrl: '/DvDetail',
    listUrl: '/DvList',
    mapProp: 'dvMap',
    name: '数据视图',
    textProp: 'dvName',
    type: 'DV',
}
